<template>
    <div class="header-form-second-step">
        <div class="d-flex flex-row bd-highlight mb-3">
            <div>
                <DynamicIcon icon="padlock" :classString="'container-modal-title-icon mr-2'"/>
            </div>
            <div class="color"><h5>Token de Acesso</h5></div>
        </div>
        <div class="d-flex">
             <h6> {{ title }} </h6> 
        </div>
    </div>
</template>

<script>
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import { SMS } from "@/util/utils"
export default {
	name: "App",
    props:{
        authType: String
  },
	components: {
		DynamicIcon
	},
    computed: {
      title () {
        return this.authType == SMS ? "Token via SMS" : "Microsoft Authenticator";
      }
    },
}
</script>
<style scoped>

.header-form-second-step {
    margin: 0px;
    line-height: 1.334;
    letter-spacing: 0em;
    font-family: optum-sans-bold;
    font-weight: 700;
    font-size: 16px;
}

.color {
    color: rgb(0, 38, 119);
}

h5 {
    border-bottom: 4px solid rgb(0, 38, 119);
}

</style>